/**
 * paywall_style 埋点字段：付费墙样式枚举与解析。
 * 取值与 UI 渲染条件保持一致（列数规则见 paywall-list/index.tsx：列表档位 < 5 个时双列，否则三列）：
 * - split_carousel_card    上下分开，上面是订阅轮播图，下面是金币卡片（split 开关开且有订阅档位）
 * - coins_only_two_column  没有轮播，双列且只有币，没有订阅卡片（无订阅档位且列表档位 < 5 个）
 * - original_three_column  没有轮播，列表里既有订阅也有金币（其余情况统一归到原始样式）
 */
export type TPaywallStyle = 'original_three_column' | 'coins_only_two_column' | 'split_carousel_card';

/**
 * 根据 split 开关、订阅档位数与列表实际档位数解析付费墙样式。
 * packageCount 为下方列表实际渲染的档位数（split 轮播样式下仅含充值档，否则为订阅+充值全部档位）。
 */
export function resolvePaywallStyle(
    splitSubscribe: boolean,
    subscribeCount: number,
    packageCount: number
): TPaywallStyle {
    if (splitSubscribe && subscribeCount > 0) {
        return 'split_carousel_card';
    }
    if (subscribeCount === 0 && packageCount < 5) {
        return 'coins_only_two_column';
    }
    return 'original_three_column';
}
